export const timeSpanFormatString = "RoEJDe";
export default {timeSpanFormatString};